import React, { useMemo } from 'react';
import { Form, Input, Row, Col, Switch } from 'antd';
import { useNavigate } from 'react-router-dom';
import PATH from '@/config/paths/PATH';
import AppForm from '@/components/AppForm';
import { updateTopic } from '@/services/topic.service';
import { useMutation } from '@tanstack/react-query';
import AppPageTitle from '@/components/AppPageTitle';
import useTopic from '@/redux/hooks/useTopic';
import useFormSubmit from '@/hooks/useFormSubmit';
import useMediaQuery, { mediaQueryPoints } from '@/hooks/useMediaQuery';

const TopicUpdate = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const { topic, clearEditingTopicValues } = useTopic();

  const initialValues = useMemo(() => {
    if (!topic.editTopic) return {};
    return topic.editTopic;
  }, [topic.editTopic]);
  const topicMutation = useMutation({
    mutationFn: updateTopic,
  });

  const handleOnSubmit = useFormSubmit(
    topicMutation,
    (values) => ({
      ...values,
      is_active: values.is_active ? 1 : 0,
      id: initialValues?.id,
    }),
    {
      onOk: async () => {
        await navigate(PATH.TOPIC.ROOT, {
          replace: true,
        });
        clearEditingTopicValues();
      },
    }
  );

  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoints.md}px)`);

  return (
    <div>
      <AppPageTitle title="Update Topic" />
      <AppForm
        form={form}
        initialValues={initialValues}
        onSubmit={handleOnSubmit}
        targetPath={PATH.TOPIC.ROOT}
        buttonProps={{
          loading: topicMutation.isPending,
          disabled: topicMutation.isPending,
        }}
        disabled={topicMutation.isPending}
      >
        <Row gutter={16}>
          <Col span={isMobile ? 24 : 12}>
            <Form.Item
              label="Name English"
              name="name_en"
              rules={[{ required: true, message: 'Please enter English name' }]}
            >
              <Input placeholder="Enter name english" />
            </Form.Item>
          </Col>
          <Col span={isMobile ? 24 : 12}>
            <Form.Item
              label="Name Myanmar"
              name="name_my"
              rules={[{ required: true, message: 'Please enter Myanmar name' }]}
            >
              <Input placeholder="Enter name myanmar" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item name="is_active" valuePropName="checked" label="Active">
          {/* <Checkbox >Active</Checkbox> */}
          <Switch title="Active" />
        </Form.Item>
      </AppForm>
    </div>
  );
};

export default TopicUpdate;
